import { combineReducers } from "@reduxjs/toolkit";
import appReducer from "./app/reducer";
import userReducer from "./user/reducer";
import pointReducer from "./point/reducer";
import brandReducer from "./brand/reducer";
import groupOperationsReducer from "./group-operations/reducer";
import modifierReducer from "./modifiers/reducer";
import cityReducer from "./city/reducer";
import ordersReducer from "./orders/reducer";

export const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  brand: brandReducer,
  point: pointReducer,
  groupOperations: groupOperationsReducer,
  modifier: modifierReducer,
  city: cityReducer,
  orders: ordersReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
